<script lang="ts">
  import { createEventDispatcher } from "svelte";

  export let noBack: boolean;

  const dispatcher = createEventDispatcher();
</script>

<div class="lrs-panel-header">
  <button class="lrs-nav-prev" on:click={(_) => dispatcher("prev")} />
  <div class="lrs-panel-title" class:lrs-panel-btn={!noBack} on:click={(_) => dispatcher("back")}>
    <slot />
  </div>
  <button class="lrs-nav-next" on:click={(_) => dispatcher("next")} />
</div>

<style lang="scss" global>
  .lrs-panel-header {
    display: flex;
    justify-content: space-between;
    padding: 0.5em;

    .lrs-panel-title {
      align-self: center;
      text-align: center;
      font-weight: bold;
      font-size: 1.2em;
      padding: 0.5em;
    }

    .lrs-panel-btn {
      padding: 0.5em 1em;
      border-radius: 9999px;
      cursor: pointer;

      &:hover {
        background-color: rgba(#000, 0.1);
      }
    }
  }

  %btn {
    background: none;
    border: none;
    font: inherit;
    color: inherit;
    cursor: pointer;
  }

  .lrs-nav-prev,
  .lrs-nav-next {
    @extend %btn;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 3em;
    height: 3em;
    padding: 0;
    border-radius: 50%;
    visibility: hidden;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      border-radius: 50%;
      color: rgba(#000, 0.1);
      background: transparent radial-gradient(circle, transparent 98.9%, currentColor 99%) center/104%;
    }

    &:hover:before {
      transition: background cubic-bezier(0.18, 1.04, 0.41, 1.01) 300ms;
      background: transparent radial-gradient(circle, currentColor 1%, transparent 1.1%) center/15000%;
    }

    &:focus {
      outline: 0 none;
      box-shadow: 0 0 0 0.1em rgba(0, 123, 255, 0.25);
    }

    &:after {
      content: "";
      border-right: solid 1px currentColor;
      border-bottom: solid 1px currentColor;
      border-radius: 2px;
      width: 1.5em;
      height: 1.5em;
    }
  }

  .lrs-nav-prev {
    left: 0;

    &:after {
      transform: translateX(0.4em) rotate(135deg) scale(0.9);
    }
  }

  .lrs-nav-next {
    right: 0;

    &:after {
      transform: translateX(-0.4em) rotate(-45deg) scale(0.9);
    }
  }
</style>
